const UserModel = require("@/appModel/users/UserModel") 
const UserInfo = require("@/appUtils/UserInfo")
const NoticeModel = require("@/appModel/Notice/NoticeModel") 
const NoticeStatusModel = require("@/appModel/NoticeStatus/NoticeStatusModel") 

class NoticeListVM {
  constructor(tenantId, userSub) {
    this.tenantId = tenantId
    this.userSub = userSub
  }
  /*
   * 初期化 ユーザーリスト取得
  */
  async init() {
    // ユーザーリスト取得
    let workList = await UserModel.getUserList(this.tenantId);
    workList = await this.filterDeleteUsers(workList);

    // ログインしているユーザーの通知情報取得
    // const loginInfo = await UserInfo.getUserInfo();
    
    let response = await NoticeStatusModel.getNoticeStatusList(this.userSub, this.tenantId);
    // console.log("ステータス取得件数：" + response.length);
    // console.log("ステータス取得：" + JSON.stringify(response));

    // ログインしているユーザーは一覧から除外
    // workList = await workList.filter(function (item){
    //   if (item.user.userId != this.userSub)
    //     return true; 
    // }.bind(this))

    // ユーザー一覧に、通知情報が紐づくかチェック（紐づけば太字にするためのプロパティーに値をセット）
    for (let i=0; i<response.length; i++){      
      let strSKs = String(response[i].sk).split('#');
      //   console.log("対象のユーザーIDは："+ strSKs[2]);
      //   console.log("対象のユーザーがこのなかにいる："+ JSON.stringify(workList));

      // ユーザーIDが一致すれば、お知らせ有無フラグの値をセット
      let value = workList.filter(function (item){
        if (item.user.userId == strSKs[2])
          return true; 
      })
      if (value.length >0)
        value[0].boldFlag = response[i].noticestatus.flg;
    }

    // ユーザーリストにお知らせ有無フラグで判定した結果のリストを返却
    this.data = workList
  }

  /**
   * 削除ユーザ以外のユーザー一覧を取得します。
   * @param {*} userList ユーザー一覧
   * @returns 削除ユーザー、無効ユーザー以外のユーザー一覧
   */
  async filterDeleteUsers(userList) {
    return userList.filter(function (item) {
      console.log(item.user.deleted);
      // 削除フラグがfalseかつ、statusが1(有効)を対象とする
      if ((item.user.deleted == null || item.user.deleted == false) && item.user.status == '1')
        return true;
    })  
  }

  /*
   * ユーザーIDから通知情報を取得
   *
   * @param {*} selectUserID 通知画面で選択したユーザーのユーザーID
  */
  async getNoticeInfo(selectUserID){
    const list = await NoticeModel.getNoticeListByselectUserID(selectUserID, this.tenantId);
    // ミーティングに関する通知は除く
    this.noticeList = list.filter((item) => {
      return item.type == "2";
    });
  
  }

  /*
   * お知らせ情報の既読フラグを更新
   *
   * @param {*} data お知らせ情報
  */
  async updateNoticeReaded(data){
    NoticeModel.updateNotice(data);
  }
 
  /*
   * お知らせ有無フラグ取得
   *
   * @param {*} data お知らせ情報
  */
  async getNoticeStatusInfo(userId){
    return await NoticeStatusModel.getNoticeStatusList(userId, this.tenantId);
  }

  /*
   * お知らせ有無フラグ取得フラグを更新
   *
   * @param {*} data お知らせ有無フラグ
  */
  async updateNoticeStatusFlg(data){
    NoticeStatusModel.updateNoticeStatus(data);
  }

  
}
module.exports = NoticeListVM;

